import bem from 'utils/bem';

export const block = bem('asset-overlay-label');
